import { ComponentType, lazy, Suspense } from 'react';

import Layout from '@components/features/Layout';
import { ENV } from '@utils/env';

type LazyFn = () => Promise<{ default: ComponentType<any> }>;

const EXPIRATION_KEY = '_lazy_import_expiration';
const ERROR_EXPIRATION_TIME = 60000; // 1 min

function shouldRefresh() {
  if (ENV.dev) return false;
  const expiration = localStorage.getItem(EXPIRATION_KEY);
  if (!expiration) return true;
  const expirationTime = Number.parseInt(expiration, 10);
  if (isNaN(expirationTime)) return true;
  const isExpired = new Date().getTime() > expirationTime;
  return isExpired;
}

function setRefreshExpiration() {
  const now = new Date().getTime();
  const expirationTime = now + ERROR_EXPIRATION_TIME;
  localStorage.setItem(EXPIRATION_KEY, expirationTime.toString());
}

const refreshComponent = () => null;

async function handleFailedLazy(lazyfn: LazyFn) {
  try {
    return await lazyfn();
  } catch (err) {
    if (shouldRefresh()) {
      setRefreshExpiration();
      window.location.reload();
      return { default: refreshComponent };
    } else {
      throw err;
    }
  }
}

export function lazyRoute(importfn: LazyFn) {
  const LazyComponent = lazy(() => handleFailedLazy(importfn));

  return function LazyRoute(props: Record<string, unknown>) {
    return (
      <Suspense fallback={<Layout.Loader />}>
        <LazyComponent {...props} />
      </Suspense>
    );
  };
}
